// extracted by mini-css-extract-plugin
export var productImagesContainer = "ProductImages-module--productImagesContainer--Tew0C";
export var imageMainContainer = "ProductImages-module--imageMainContainer--2rIJ7";
export var fadein = "ProductImages-module--fadein--3FY37";
export var imageThumbContainer = "ProductImages-module--imageThumbContainer--3WeDB";
export var thumbnail = "ProductImages-module--thumbnail--OXvkV";